import { useTrackBrowseEventWithCondition } from '@/hooks/useTrackBrowseEventWithCondition';
import { ReactComponent as InfoSvg } from '@/images/icon_info.svg';
import { trackEvent, trackType } from '@/utils/trackUtils';
import { t } from 'i18next';
import { useState } from 'react';
import CommonDialog from '../CommonDialog';
import style from './index.module.less';

export type CommonAnnotationProps = {
  title?: string;
  content: string;
  iconSize?: number;
  onClickShow?: () => void; // 点击图标
  trackOnShow?: { trackType: Array<trackType>; eventName: string; params?: any }; // 弹窗显示
  trackOnClose?: { trackType: Array<trackType>; eventName: string; params?: any }; // 弹窗关闭
  showBottomCover?: boolean;
  clsName?: string;
};

function CommonAnnotation(props: CommonAnnotationProps) {
  const {
    title,
    content,
    iconSize,
    onClickShow,
    trackOnShow,
    trackOnClose,
    showBottomCover = true,
    clsName,
  } = props;
  const [show, setShow] = useState(false);
  useTrackBrowseEventWithCondition(
    trackOnShow?.trackType || [],
    trackOnShow?.eventName || '',
    trackOnShow?.params || null,
    [show],
    [show]
  );

  return (
    <>
      <InfoSvg
        className={`${style.icon} ${clsName}`}
        style={{ width: iconSize, height: iconSize }}
        onClick={(e: MouseEvent) => {
          e.stopPropagation();
          onClickShow && onClickShow();
          setShow(true);
        }}
      />
      <CommonDialog
        visible={show}
        title={title}
        content={content}
        onConfirm={() => {
          trackOnClose &&
            trackEvent(
              trackOnClose.trackType,
              trackOnClose.eventName,
              trackOnClose?.params || null
            );
          setShow(false);
        }}
        confirmButtonText={t<string>('introduction_know')}
        showBottomCover={showBottomCover}
      />
    </>
  );
}

export default CommonAnnotation;
